import { Helmet } from 'components';
import { Layout } from './components';

const Unsubscribe: React.FunctionComponent = function () {
  return (
    <Layout>
      <Helmet title="Unsubscribe" />
      <div className="flex flex-col m-auto">
        <p className="text-16-24-em text-center">
          You have been removed from Ideal4Finance&apos;s mailing list
        </p>
      </div>
    </Layout>
  );
};

export default Unsubscribe;
